import { jobOpportunitySelector } from "./selector";
import RadioGroup from "../common/RadioGroup";
import { useSelector, useDispatch } from "react-redux";
import { setTemplateInfo } from "./action";
import TextField from "../common/TextField/withLabel";

export default (props) => {
    const { masterData, templateInfo, selectedOption } = useSelector(jobOpportunitySelector);
    const dispatch = useDispatch();

    const updateTemplateInfoStatus = (data) => {
        dispatch(setTemplateInfo(data));
    };

    const getRelevantDropdown = () => {
        if (selectedOption.fromTemplate) {
            return masterData?.fromTemplateInfo;
        } else if (selectedOption.createTemplate) {
            return masterData?.createTemplateInfo;
        }
        return masterData?.allTemplateInfo;
    };

    if(selectedOption.editJobPost) {
        return <div></div>
    }
    return (
        <div className="card h-100">
            <div className="col-lg-12 col-md-12">
                <div className="row">
                    <div className="card-header">
                        <h3 class="card-title">Template Info<span class="required">*</span></h3>
                    </div>
                    <div className="card-body">
                        <div class="row">
                            <RadioGroup options={getRelevantDropdown()}
                                name={'option'}
                                value={templateInfo?.option}
                                updateValue={updateTemplateInfoStatus}
                            />
                            {props.errors && props.errors['templateIntoType']?.map(error => (<div className="invalid-input">{error}</div>))}
                                <div className="pt-2">
                                        {(templateInfo?.option === 1) &&
                                        <TextField name={'name'}
                                            id={'name'}
                                            label={'Template Name'}
                                            star={'*'}
                                            value={templateInfo?.name}
                                            updateValue={updateTemplateInfoStatus} isObject={true}
                                            errors={props.errors ? props.errors['templateName'] : []}
                                        />
                                    }
                                </div>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
